"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSyncedImportantRando = exports.getUUnsyncedUnimportantRando = exports.getSyncedUnimportantRando = exports.reset = exports.get = void 0;
var randoInstanced_sidecar_1 = require("@dive/to-engine/randoInstanced-sidecar");
var _obj = null;
var get = function () {
    if (!_obj) {
        var seed = 100;
        _obj = {
            masterSeed: seed,
            // Temp create, will get overwritten by reset
            unsyncedUnimportantRando: randoInstanced_sidecar_1.randoInstanced.createRando(seed),
            syncedUnimportantRando: randoInstanced_sidecar_1.randoInstanced.createRando(seed + 1),
            syncedImportantRando: randoInstanced_sidecar_1.randoInstanced.createRando(seed + 2),
            synced_idCounter: 0,
        };
        reset(Date.now());
    }
    return _obj;
};
exports.get = get;
function reset(masterSeed) {
    if (masterSeed === void 0) { masterSeed = 0; }
    var obj = exports.get();
    if (!masterSeed) {
        masterSeed = obj.masterSeed + 1;
    }
    obj.masterSeed = masterSeed;
    var seedMin = 1000;
    var seedMax = 1000 * 1000 * 10 - 1;
    obj.syncedImportantRando = randoInstanced_sidecar_1.randoInstanced.createRando(masterSeed);
    obj.unsyncedUnimportantRando = randoInstanced_sidecar_1.randoInstanced.createRando(obj.syncedImportantRando.i(seedMin, seedMax));
    obj.syncedUnimportantRando = randoInstanced_sidecar_1.randoInstanced.createRando(obj.syncedImportantRando.i(seedMin, seedMax));
}
exports.reset = reset;
function getSyncedUnimportantRando() {
    var obj = exports.get();
    return obj.syncedUnimportantRando;
}
exports.getSyncedUnimportantRando = getSyncedUnimportantRando;
function getUUnsyncedUnimportantRando() {
    var obj = exports.get();
    return obj.unsyncedUnimportantRando;
}
exports.getUUnsyncedUnimportantRando = getUUnsyncedUnimportantRando;
function getSyncedImportantRando() {
    var obj = exports.get();
    return obj.syncedImportantRando;
}
exports.getSyncedImportantRando = getSyncedImportantRando;
